// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmPhoneDTOAPIModel
 */
export interface ConfirmPhoneDTOAPIModel {
    /**
     * 
     * @type {string}
     * @memberof ConfirmPhoneDTOAPIModel
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmPhoneDTOAPIModel
     */
    phone: string;
}

export function ConfirmPhoneDTOAPIModelFromJSON(json: any): ConfirmPhoneDTOAPIModel {
    return ConfirmPhoneDTOAPIModelFromJSONTyped(json, false);
}

export function ConfirmPhoneDTOAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmPhoneDTOAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'phone': json['phone'],
    };
}

export function ConfirmPhoneDTOAPIModelToJSON(value?: ConfirmPhoneDTOAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'phone': value.phone,
    };
}


